import React, { Component } from 'react'

export class ShowFullItem extends Component {
  render() {
    return (
      <div className='fullItem' onClick={()=>this.props.onShowItem()}>
        <div className='item'>
            <img className='item__img' alt={this.props.item.category} src={this.props.item.img}/>
                <h2 className='item__titl'>{this.props.item.title}</h2>
                <p className='item__desc'>{this.props.item.desc}</p>
                <div className='item__footer'>
                    <p className='item__footer-price'>{this.props.item.price}</p>
                    <div className='item__footer-add' onClick={ () => this.props.onAdd(this.props.item)}>+</div>
                </div>
        </div>
      </div>
    )
  }
}

export default ShowFullItem